"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MultiColumnRow", {
  enumerable: true,
  get: function get() {
    return _MultiColumnRow.MultiColumnRow;
  }
});
Object.defineProperty(exports, "ThreeColumnRow", {
  enumerable: true,
  get: function get() {
    return _MultiColumnRow.ThreeColumnRow;
  }
});
Object.defineProperty(exports, "TwoColumnRow", {
  enumerable: true,
  get: function get() {
    return _MultiColumnRow.TwoColumnRow;
  }
});

var _MultiColumnRow = require("./MultiColumnRow");